import styled from 'styled-components';

import { device } from 'components/styles/MediaQuery';
import {
  reversedGemAnimation,
  gemAnimation,
} from 'components/JackpotGemsPack/styled';

export const ScJackpotModals = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  color: ${({ theme }) => theme.whiteColor};

  @media (${device.mobile}) {
    gap: 24px;
  }

  & > .title {
    text-align: center;
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: 0.01em;

    @media (${device.mobile}) {
      font-size: 18px;
    }
  }

  & > .img_wrapper {
    position: relative;

    width: 100%;
    height: 72px;

    & > .bg {
      position: absolute;

      width: 100%;
      height: 100%;

      border-radius: 12px;
    }

    .logo {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 2;

      width: 126px;
      height: 64px;

      transform: translate(-50%, -50%);
    }
  }

  .terms {
    display: flex;
    flex-direction: column;
    gap: 21px;

    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  .btn-wrapper {
    width: 232px;

    @media (${device.mobileXS}) {
      width: 100%;
    }

    button {
      width: 100%;
    }
  }
`;

export const ScWinnerJackpot = styled.div`
  z-index: 1;

  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (${device.mobile}) {
    flex-direction: column;
    flex-wrap: wrap;
  }

  & > .content {
    display: flex;
    gap: 32px;
    padding: 32px 70px;
    flex-direction: column;
    align-items: center;

    color: ${({ theme }) => theme.whiteColor};

    @media (${device.mobileS}) {
      padding: 16px 12px;
    }

    .title {
      text-align: center;
      font-size: 24px;
      font-weight: 800;
      line-height: 32px;
      letter-spacing: 0.02em;
    }

    .subtitle {
      font-size: 24px;
      font-weight: 800;
      line-height: 32px;
      letter-spacing: 0.02em;
      color: rgba(255, 255, 255, 0.6);
    }

    .prize {
      font-size: 48px;
      font-weight: 800;
      line-height: 56px;
      letter-spacing: 0.03em;
      text-align: center;
    }
  }

  & > .logo_wrapper {
    position: relative;

    display: flex;
    width: 264px;
    height: 264px;

    .logo {
      max-width: 100%;
      object-fit: contain;
      z-index: 1;
    }

    & > .blueWithConfetti,
    .pinkWithConfetti {
      position: absolute;
    }

    .blueWithConfetti {
      right: 70px;
      bottom: 20px;
      animation: ${reversedGemAnimation} infinite 7s ease-out;
    }

    .pinkWithConfetti {
      right: 4px;
      bottom: 84px;
      animation: ${gemAnimation} infinite 7s ease-out;
    }
  }
`;
